import { useEffect, useRef } from 'react'
import { useWorkspaceStore } from '@/store/workspaceStore'
import {
  applyWorkspaceChatSnapshot,
  emptyWorkspaceChatSnapshot,
  readWorkspaceChatSnapshot,
  snapshotFromChatModel,
  writeWorkspaceChatSnapshot,
} from '@/store/workspaceChatCache'

/** Swap threads, messages, and project context when the active workspace changes. */
export function useWorkspaceChatScope(model) {
  const workspaceId = useWorkspaceStore((s) => s.activeWorkspaceId)
  const prevIdRef = useRef(null)
  const modelRef = useRef(model)
  modelRef.current = model

  useEffect(() => {
    if (!workspaceId) return
    const prevId = prevIdRef.current
    if (prevId === workspaceId) return

    const current = modelRef.current
    if (prevId) writeWorkspaceChatSnapshot(prevId, snapshotFromChatModel(current))

    const snapshot = readWorkspaceChatSnapshot(workspaceId) ?? emptyWorkspaceChatSnapshot()
    applyWorkspaceChatSnapshot(current, snapshot)
    prevIdRef.current = workspaceId
  }, [workspaceId])
}
